var _path, _line, _line2, _line3, _line4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0194 1.81444C10.0622 1.58504 10.184 1.37786 10.3635 1.22876C10.543 1.07966 10.769 0.998047 11.0024 0.998047C11.2358 0.998047 11.4618 1.07966 11.6413 1.22876C11.8208 1.37786 11.9425 1.58504 11.9854 1.81444L13.0364 7.37244C13.111 7.76759 13.3031 8.13106 13.5874 8.41541C13.8718 8.69977 14.2352 8.8918 14.6304 8.96644L20.1884 10.0174C20.4178 10.0603 20.625 10.182 20.7741 10.3615C20.9232 10.5411 21.0048 10.7671 21.0048 11.0004C21.0048 11.2338 20.9232 11.4598 20.7741 11.6393C20.625 11.8189 20.4178 11.9406 20.1884 11.9834L14.6304 13.0344C14.2352 13.1091 13.8718 13.3011 13.5874 13.5855C13.3031 13.8698 13.111 14.2333 13.0364 14.6284L11.9854 20.1864C11.9425 20.4158 11.8208 20.623 11.6413 20.7721C11.4618 20.9212 11.2358 21.0028 11.0024 21.0028C10.769 21.0028 10.543 20.9212 10.3635 20.7721C10.184 20.623 10.0622 20.4158 10.0194 20.1864L8.96839 14.6284C8.89375 14.2333 8.70172 13.8698 8.41737 13.5855C8.13301 13.3011 7.76954 13.1091 7.37439 13.0344L1.81639 11.9834C1.587 11.9406 1.37981 11.8189 1.23071 11.6393C1.08162 11.4598 1 11.2338 1 11.0004C1 10.7671 1.08162 10.5411 1.23071 10.3615C1.37981 10.182 1.587 10.0603 1.81639 10.0174L7.37439 8.96644C7.76954 8.8918 8.13301 8.69977 8.41737 8.41541C8.70172 8.13106 8.89375 7.76759 8.96839 7.37244L10.0194 1.81444Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 19.002,
    y1: 0.75,
    x2: 19.002,
    y2: 5.25,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 16.752,
    y1: 3,
    x2: 21.252,
    y2: 3,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 4.62695,
    y1: 17.5,
    x2: 4.62695,
    y2: 19.5,
    stroke: "white",
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 3.50195,
    y1: 18.375,
    x2: 5.50195,
    y2: 18.375,
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiStar);
export default __webpack_public_path__ + "static/media/ai_star.98695d02d1c4e199fb5abf743da889c7.svg";
export { ForwardRef as ReactComponent };